<template>
    <div>
        <v-card class="elevation-3 mb-4 justify-center">
            <v-card-text>
                <v-container fluid>
                    <v-row  justify="space-between">
                        <v-col class="justify-center headline" cols="6" md="6">Report Configuration</v-col>
                        <v-col class="text-right" cols="4" md="2" >
                            <v-btn color="secondary" class="elevation-1" small dark v-on:click="$emit('closeConfig')">Close <v-icon dark right>{{ getIcon('close') }}</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <v-row class='configlead'>
                        <p>Some data in the page will not refresh until you close the configuration panel.</p>
                    </v-row>
                    <v-expansion-panels multiple >
                        <v-expansion-panel>
                            <v-expansion-panel-header>General Settings</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click.stop="togglehelp('generalhelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="generalhelp" v-if="showhelp === 'generalhelp'"  >
                                    <p>The report is always accessible to users who are logged in as Owners or Editors on your account.
                                    "<strong>Enable Public Report</strong>" makes the report publicly accessible to others who are not
                                        logged in.</p>
                                    <p><strong>The Banner</strong> is displayed at the top of the report.  You can put a report title here, or a full HTML banner with your logo.
                                    This block can by styled using the #reportTitleContainer id in the CSS block under "Custom Content".  If you don't want a banner or title
                                    (for example, if you embed this report in something else), just leave this field blank.  </p>
                                    <p>The <strong>Page Title</strong> is used to customize what is displayed in the title tag.  This is used
                                        by the browser to name the tab and/or window, not for display in the page itself.  To modify the banner
                                        at the top of the page, see the settings under Custom Content.</p>
                                    <p>The <strong>Custom Domain</strong> is used to make the report accessible on your own custom domain.
                                        This must be a domain that you control, and you should set it as a CNAME to point to
                                        nodeping.com.  This is optional, and the report is available on nodeping.com without a custom domain
                                        set up.</p>
                                    <p>The <strong>Access Phrase</strong> allows you to require people to enter an access phrase in order to access the report.
                                        This is for convenience to obscure non-public information.  <strong>This is not designed as a security feature, and is not
                                        encrypted.</strong> It is, for example, visible in your configuration settings. The Access Phrase field supports most special
                                        characters, but some unsupported/unsafe characters will be stripped.  If you need login control for your reports, use
                                        account contacts instead.</p>
                                </v-row>
                                <v-container>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.enable" :label="getLabel('enable')"  @click.stop="saveConfig(!reports_statusevents.reportConfig.enable, 'enable')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="domain" :value="reports_statusevents.reportConfig.domain" :label="getLabel('domain')" @change="saveConfig($event, 'domain')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row  justify="space-between" style="width:100%">
                                        <v-textarea name="title" :value="reports_statusevents.reportConfig.title" :label="getLabel('title')" rows="2" auto-grow  @change="saveConfig($event, 'title')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="pagetitle" :value="reports_statusevents.reportConfig.pagetitle" :label="getLabel('pagetitle')" @change="saveConfig($event, 'pagetitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="accessphrase" :value="reports_statusevents.reportConfig.accessphrase" :label="getLabel('accessphrase')" @change="saveConfig($event, 'accessphrase')" >
                                        </v-text-field>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        <v-expansion-panel>
                            <v-expansion-panel-header>Summary Panel</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click.stop="togglehelp('summaryconfighelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row  class='helptext' id="summaryconfighelp" v-if="showhelp === 'summaryconfighelp'">
                                    <p><strong>The Summary Panel</strong> is used to summarize the overall status of all the checks included in the report in one place.</p>
                                    <p>The Summary Panel can optionally <strong>Show Down Checks</strong>.  This is particularly useful if you aren't
                                        showing the Checks block (configured in the next session). If the option to show links to checks is enabled in the Checks section,
                                        links will be displayed in the Summary Panel when down checks are listed so users can access the detailed check status report.</p>
                                    <p>You can customize the background color of this panel by setting styling in the CSS section under "Custom Content".  If any checks
                                        are down, the summary panel will have a class of "summaryblockdown".  If all of the checks are up it will have a class of
                                        "summaryblockup".</p>
                                </v-row>
                                <v-container>
                                    <v-row style="width:100%">
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showsummary" :label="getLabel('showsummary')" @click.stop="saveConfig(!reports_statusevents.reportConfig.hidesummary, 'hidesummary', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showsummarydown" :label="getLabel('showsummarydown')" @click.stop="saveConfig(!reports_statusevents.reportConfig.showsummarydown, 'showsummarydown', 'toggle')" ></v-checkbox>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header>Checks</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click.stop="togglehelp('checkconfighelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row  class='helptext' id="checkconfighelp" v-if="showhelp === 'checkconfighelp'">
                                    <p>The settings in this section will impact all checks on the report.  For the "normal" layout, you can also set some
                                        options on individual checks.  Scroll down while the settings panel is open
                                        to manage settings for individual checks.  While the Settings panel is open, you can also drag checks to reorder
                                        them on the report.  Since the "compact" view is displayed in a table with standard columns and built in sorting,
                                        some features for individual checks are not available for that view.</p>
                                    <p>You can <strong>Include All Checks</strong> on the report, or select individual checks to include.  As you add and remove
                                        checks from your account this will continue to reflect the current list.  However, if you enable Include All Checks you
                                        cannot reorder them or configure options on the report for individual checks.  This option may not work well if you have
                                        more than a few hundred checks on your account.</p>
                                    <p>You can choose to display all of the checks on the report regardless of their status, or to <strong>hide passing</strong> or <strong>disabled checks</strong> in the list.
                                        If "Show Check Status List" is off, these other settings are ignored.</p>
                                    <p>The <strong>Show Links</strong> option here will cause links to individual check status pages to be displayed if the check is marked as "public".
                                        If the check is not public, the report is not publicly available so the link won't be shown.  This setting also impacts the list of "down"
                                        checks in the Summary Panel if it is enabled.</p>
                                    <p>You can toggle whether or not to <strong>Show Check Uptime</strong> for each check in the report.  If you do show uptime, you can set
                                        the default metric to show for the uptime.  This can also be configured on each check individually.</p>
                                    <p><strong>Show Check Description</strong> toggles whether or not to display the information you have set as the check description in the check's
                                        properties. </p>
                                </v-row>
                                <v-container>
                                    <v-row style="width:100%">
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showchecks" :label="getLabel('showchecks')" @click.stop="saveConfig(!reports_statusevents.reportConfig.hidechecks, 'hidechecks', 'toggle')" ></v-checkbox>
                                    </v-row>

                                    <v-row justify="space-between">
                                        <v-checkbox :input-value="!!reports_statusevents.reportConfig.includeallchecks" :label="getLabel('includeallchecks')" @click.stop="saveConfig(!reports_statusevents.reportConfig.includeallchecks, 'includeallchecks', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between" v-if="!reports_statusevents.reportConfig.includeallchecks" class="mb-3">
                                        <v-select :items="checkSelectList()" :label="getLabel('addcheck')" @input="addCheck($event)" :messages="fieldSchema.addcheck.messages" />
                                    </v-row>
                                    <v-row  justify="space-between" >
                                        <v-select :items="[{value:'normal',text: 'Normal'},{value:'compact', text:'Compact'}]" :label="getLabel('checklayout')" :value="reports_statusevents.reportConfig.checklayout" @input="saveConfig($event, 'checklayout')" />
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.hideupchecks" :label="getLabel('hideupchecks')" @click.stop="saveConfig(!reports_statusevents.reportConfig.hideupchecks, 'hideupchecks', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.hidedisabledchecks" :label="getLabel('hidedisabledchecks')" @click.stop="saveConfig(!reports_statusevents.reportConfig.hidedisabledchecks, 'hidedisabledchecks', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showtype" :label="getLabel('showtype')"  @click.stop="saveConfig(!reports_statusevents.reportConfig.showtype, 'showtype', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showdescription" :label="getLabel('showdescription')"  @click.stop="saveConfig(!reports_statusevents.reportConfig.showdescription, 'showdescription', 'toggle')" ></v-checkbox>
                                    </v-row>

                                    <v-row  justify="space-between">
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showlinks" :label="getLabel('showlinks')"  @click.stop="saveConfig(!reports_statusevents.reportConfig.showlinks, 'showlinks', 'toggle')" ></v-checkbox>
                                    </v-row>

                                    <v-row  justify="space-between">
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showcheckuptime" :label="getLabel('showcheckuptime')"  @click.stop="saveConfig(!reports_statusevents.reportConfig.hidecheckuptime, 'hidecheckuptime', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-select :items="availablemetrics" :label="getLabel('availablemetrics')" :value="reports_statusevents.reportConfig.displaymetric" @input="saveConfig($event, 'displaymetric')" />
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header>Events</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click.stop="togglehelp('eventsconfighelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row  class='helptext' id="eventsconfighelp" v-if="showhelp === 'eventsconfighelp'">
                                    <p>This section allows you to manage how Events History is displayed.</p>
                                    <p><strong>Show Events</strong> toggles whether to show events on the report. </p>
                                    <p><strong>Events Block Title</strong> sets the title shown at the top of the events block.  The default is "Past Events".</p>
                                    <p><strong>Pagination Interval</strong> sets how much event history to fetch at a time.  There is also a hard numeric pagination limit of 300 records.
                                        "All" makes the page display all events from the shortest of the numeric limit, the time the check was created or, if it's set, the "Do Not Show
                                        Events Older Than" setting.  Combining a pagination of "All" with "Show Days with No Events" is not recommended, because you might end up with a
                                        lot of days listed.</p>
                                    <p><strong>Do Not Show Events Older Than</strong> prevents querying for events older than the span of time indicated.</p>
                                    <p><strong>Show Days with No Events</strong> makes the page list each page in the timespan with a "No Events Reported" message (which you can set in the next field)</p>
                                    <p><strong>Text displayed when there are no events</strong> sets what to display if there are no events in the displayed interval (or on that day
                                        if you are displaying empty days).  Defaults to "No events reported".</p>
                                </v-row>
                                <v-container>
                                    <v-row style="width:100%">
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showevents" :label="getLabel('showevents')" @click.stop="saveConfig(!reports_statusevents.reportConfig.hideevents, 'hideevents', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="eventtitle" :value="reports_statusevents.reportConfig.eventtitle" :label="getLabel('eventtitle')" @change="saveConfig($event, 'eventtitle')" >
                                        </v-text-field>
                                    </v-row>
                                    <v-row>
                                        <v-select :items="[{value:'months', text:'One Month'}, {value:'weeks', text:'One Week'}, {value:'days', text:'One Day'}]" :label="getLabel('eventsinterval')" :value="reports_statusevents.reportConfig.eventsinterval" @input="saveConfig($event, 'eventsinterval')" />
                                    </v-row>
                                    <v-row>
                                        <v-select :items="[{value:'all', text:'No limit'}, {value:'One week', text:'One Week'}, {value:'Two weeks', text:'Two Weeks'}, {value:'One month', text:'One Month'}, {value:'Three month', text:'Three Months'}]" :label="getLabel('eventsnotbefore')" :value="reports_statusevents.reportConfig.eventsnotbefore" @input="saveConfig($event, 'eventsnotbefore')" />
                                    </v-row>
                                    <v-row>
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.showemptyeventdays" :label="getLabel('showemptyeventdays')" @click.stop="saveConfig(!reports_statusevents.reportConfig.showemptyeventdays, 'showemptyeventdays', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-text-field name="noeventstext" :value="reports_statusevents.reportConfig.noeventstext" :label="getLabel('noeventstext')" @change="saveConfig($event, 'noeventstext')" >
                                        </v-text-field>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header>Custom Content - Footer, Support Content, CSS</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <div class="helpicon" >
                                    <v-icon light right color="primary" @click.stop="togglehelp('supportcontenthelp')">{{ getIcon('help') }}</v-icon>
                                </div>
                                <v-row class="helptext" id="supportcontenthelp" v-if="showhelp === 'supportcontenthelp'"  >
                                    <p>The Customizable Content blocks support either plain text or HTML.  A wide range of tags and attributes are supported, but there is some
                                        filtering to prevent misuse.  For example, script tags and event attributes will be removed.  Style attributes are supported, but we
                                        encourage you to use the CSS block instead of adding style attributes.</p>
                                    <p><strong>The Support Content</strong> block will appear in between the Check Status list and the Events list.  This is intended to
                                        display information useful to all visitors to your status page.  For example, you may want to display a link to
                                        contact support.  This block can be toggled on and off, for situational use.  To style this content, use the CSS block with the #supportcontent id.</p>
                                    <p><strong>The Footer</strong> is at the bottom of the page, and can safely be left blank if you don't need it.  To style the Footer content, use the CSS
                                        block below with the #customfooter id.</p>
                                    <p>The <strong>CSS</strong> block allows you to set styling for any element on this page.  This is particularly useful for the banner, footer, and summary
                                    block area of the report.  See the <a href="/reporting-status.html">report documentation</a> for more.</p>
                                </v-row>
                                <v-container>
                                    <v-row>
                                        <v-checkbox :input-value="reports_statusevents.reportConfig.shownote" :label="getLabel('shownote')" @click.stop="saveConfig(!reports_statusevents.reportConfig.hidenote, 'hidenote', 'toggle')" ></v-checkbox>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="note" :value="reports_statusevents.reportConfig.note" :label="getLabel('note')" rows="2" auto-grow  @change="saveConfig($event, 'note')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="footer" :value="reports_statusevents.reportConfig.footer" :label="getLabel('footer')" rows="2" auto-grow  @change="saveConfig($event, 'footer')">
                                        </v-textarea>
                                    </v-row>
                                    <v-row  justify="space-between">
                                        <v-textarea name="stylecss" :value="reports_statusevents.reportConfig.stylecss" :label="getLabel('stylecss')" rows="2" auto-grow  @change="saveConfig($event, 'stylecss')">
                                        </v-textarea>
                                    </v-row>
                                </v-container>
                            </v-expansion-panel-content>
                        </v-expansion-panel>

                        <v-expansion-panel>
                            <v-expansion-panel-header>Show Config</v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <pre>{{reports_statusevents.reportConfig}}</pre>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
// @TODO setCheck needs to set local config state without waiting for remote.
// @TODO look at changing the input fields to v-model.lazy

import appconfig from "../config/shared";
import { mapState, mapGetters } from "vuex";
import { filterHTML, filterColor, isNumber } from '../lib/filter';
import _map from 'lodash/map';
import _filter from 'lodash/filter';
import _sortBy from 'lodash/sortBy';

const fieldSchema = {
    accessphrase: {label: "Access Phrase" },
    addcheck: {label: "Add a Check", messages: "In most cases data for checks you add will not be retrieved from the server until the settings panel is closed." },
    availablemetrics: {label: "Uptime Metrics"},
    checklayout: {label: "Check List Format"},
    displaymetric: {label: "Uptime metrics" },
    domain: {label: "Custom Domain" },
    enable: {label: "Enable Public Report", shortlabel: "Public" },
    eventsinterval: {label: "Pagination Interval (How much event data to fetch at a time?)", shortlabel: "Pagination Interval" },
    eventsnotbefore: {label: "Do Not Show Events Older Than" },
    eventtitle: {label: "Events Block Title (Defaults to \"Past Events\")", shortlabel: "Events Block Title" },
    footer: {label: "Footer" },
    hidedisabledchecks: {label: "Hide Disabled Checks" },
    hideupchecks: {label: "Hide Passing Checks" },
    includeallchecks: {label: "Include All Checks (Toggling this may take a moment to update)", shortlabel: "Include All Checks" },
    noeventstext: {label: "Text displayed when there are no events (Defaults to \"No events reported\")", shortlabel: "Text for no events" },
    note: {label: "Support Note" },
    pagetitle: {label: "Page Title" },
    showchecks: {label: "Show Check Status List" },
    showcheckuptime: {label: "Show Check Uptime" },
    showdescription: {label: "Show Check Description" },
    showemptyeventdays: {label: "Show Days with No Events" },
    showevents: {label: "Show Events" },
    showlinks: {label: "Show Link to Check Report for Public Checks", shortlabel: "Show Link" },
    shownote: {label: "Show Support Note" },
    showsummary: {label: "Show Status Summary" },
    showsummarydown: {label: "Show Down Checks in Summary Panel" },
    showtype: {label: "Show Check Type" },
    stylecss: {label: "CSS" },
    title: {label: "Report Banner" }
    // pagetitle: {label: "label" },

}

export default {
    name: "ReportSettings",
    data () {
        return {
            showhelp: null,
            fieldSchema: fieldSchema,
            errormessages: {}
        }
    },
    computed: {
        ...mapState(["currentUser", "reports_statusevents", "now", "checks"]),
        ...mapGetters(["checkIds"])
    },
    props: {
        availablemetrics: {
            type: Array
        }
    },
    mounted: function () {
        // console.log('mounted', this.reports_statusevents);
    },
    methods: {
        getLabel: function(key) {
            return (fieldSchema[key] && fieldSchema[key].label) || key;
        },
        getShortLabel: function(key, subfield) {
            let label = (fieldSchema[key] && (fieldSchema[key].shortlabel || fieldSchema[key].label)) || key;
            if(subfield) label += ": " + subfield;
            return label;
        },

        addCheck: function (val) {
            // console.log('addCheck', val, this.checks.checksList);
            const timestamp =  Date.now().toString(36);
            if (val.indexOf(' ') > -1) return; // not an ID
            let record = Object.assign({}, this.checks.checksList[val], { checkid: val, report: {  } } );
            record.status = (record.enable === "inactive") ?  "inactive" : ( (record.state) ? "up" : "down" );
            this.$store.dispatch('setAlert', {message: "Adding check", key: timestamp, type: "info"})
            this.$store.dispatch('reports_statusevents/addReportCheck', record)
                .then(() => {
                    this.$store.dispatch("reports_statusevents/listChecks")
                        .then(() => {
                            this.$store.dispatch('listEvents');
                        })

                    this.$store.dispatch('setAlert', {message: "Added check", key: timestamp, type: "success"});
                })
        },
        saveConfig: function (val, field, action) {
            // console.log('saveConfig', val, field, action);
            const timestamp =  Date.now().toString(36);

            let config = {};
            if (action === "toggle"){
                val = !this.reports_statusevents.reportConfig[field];
            } else if (field === "title" || field === "note") {
                let rule = (field === "note") ? 'all': undefined;
                val = filterHTML(val, rule);
            } else if (field === "summaryupcolor" || field === "summarydowncolor"){
                if(val && val.length){
                    val = filterColor(val);
                    if(!val) return;
                }
            } else if(fieldSchema[field] && fieldSchema[field].type){
                // no fields currently implement this, but leaving it for now because it is small and provides a pattern
                let message = this.ruleHandler( val, field);
                if(message){
                    // value failed validation, set error and return.
                    // this.$root is Vue, $set makes the element reactive.
                    this.$root.$set(this.errormessages, field, message);
                    return;
                } else {
                    // value passed validation, remove error if it is set.
                    if(this.errormessages && this.errormessages[field])  this.$root.$set(this.errormessages, field, false);
                }
            } else {
                // field has no type set.  This shouldn't happen, but remove error if it is set.
                if(this.errormessages && this.errormessages[field]) this.$root.$set(this.errormessages, field, false);
            }

            this.$store.dispatch('setAlert', {message: "Saving field: "+this.getShortLabel(field), key: timestamp, type: "info"})

            // console.log('saveConfig filtered', val, field, action);
            config[field] = val;
            this.$store.dispatch('reports_statusevents/setReportConfig', config)
                .then(() => {
                    let message = "Saved field: "+this.getShortLabel(field);
                    if(field === "includeallchecks") message += ". This change may not appear immediately."
                    this.$store.dispatch('setAlert', {message: message, key: timestamp, type: "success"})
                })
                .catch( () => {
                    this.$store.dispatch('setAlert', {message: "Error Saving Field: "+this.getShortLabel(field), key: timestamp, type: "error"})
                    console.log("error saving config update");
                });
        },
        checkSelectList: function () {
            let list =
                _sortBy(
                    _filter(
                        _map(this.checks.checksList, (record) => {   // get a list of check labels and IDs
                                return {
                                    text: (record.label || (record.parameters && record.parameters.target) || record._id) + " " + record.type + (record.enable === "active" ? "" : " (disabled)"),
                                    value: record._id
                                }
                            }),
                        // filter function, remove checks already on the report.
                        // reports_statusevents.reportChecks
                        (record) => {
                                if ( !this.reports_statusevents.reportChecks) return true;

                                let i = this.reports_statusevents.reportChecks.length;
                                while ( i-- ) {
                                    if (this.reports_statusevents.reportChecks[i] === record.value || this.reports_statusevents.reportChecks[i]._id === record.value) return false;
                                }
                                return true;
                            }
                    ),
                    // sort by label, then id
                    ['text', 'value']
            );
            if (!list || !list.length) list = ["There are no checks available to add."];
            return list;
        },
        togglehelp: function (topic) {
            this.showhelp = (this.showhelp === topic) ? null : topic;
        },
        getIcon: function ( val ) {
            return appconfig.icons[val] || val;
        },
        ruleHandler: function( val, field ){
            if(!val || !field) return true;
            if(!fieldSchema[field] || !fieldSchema[field].type){ console.log("Error, invalid schema for validation."); return true; }
            // console.log(val, field, fieldSchema[field].type);
            switch(fieldSchema[field].type){
                case 'numeric':
                    // console.log("applying rules for numeric type");
                    return (isNumber(val - 0)) ? false : (fieldSchema[field].invalid || "Value is not valid for this field");
            }
            return true;
        }
    },
    watch: {
        // value() {
        //     // this.$emit('saveConfigChange', this.value);
        // }
    }
}
</script>

<style>
#summaryupcolorinput, #summarydowncolorinput {
    padding: 0 6px 0 6px;
}
</style>
<style scoped>
.helptext p {
    width: 96%;
}
.importantnote {
    font-size: 1.2em;
    font-weight: bold;
}
.helpicon {
    float: right;
}
.helptext {
    background-color: #EEE;
    padding: .8rem;
}
.configlead {
    padding: 0 12px;
}
</style>
